module.exports = __webpack_public_path__ + "d1447728ddf68aa915b8e48d53817d86.svg";